import styled from "styled-components";
import {
  colors,
  fontSizes, 
  fontWeights, 
  spacings,
  borders
} from 'styles/theme';

export const TablePagination = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: ${spacings.ls};
  margin-bottom: ${spacings.ls};

  .total-itens{
    display: flex;
    .tag {
      align-self: center;
      margin-right: 4px; 
    }
    strong{
      letter-spacing: 0.1rem;
      font-weight: ${fontWeights.w700};
      font-size: ${fontSizes.sl};
      color: ${colors.neutral_darkest};
    }
  }

  .button-paginate{
    margin: 0 ${spacings.xs};
    padding: ${spacings.sl};
    font-style: normal;
    font-weight: ${fontWeights.w700};
    font-size: ${fontSizes.sm};
    color: ${colors.neutral_darkest};
    border: ${borders.xs} solid ${colors.neutral_regular};
    border-radius: ${borders.sm};
    background-color: transparent;
    transition: 0.2s;

    &:last-child{
      margin-right: 0;
    }

    &:hover, &.isActive{
      color: ${colors.white};
      border: ${borders.xs} solid ${colors.primary};
      background-color: ${colors.primary};

      svg{
        path{
          stroke: ${colors.white};
        }        
      }
    }
  }

  .paginate{
    display: flex;
    
    .arrow-left{
      svg{
        transform: rotate(-90deg);
      }
    }

    .arrow-right{
      svg{
        transform: rotate(90deg);
      }
    }

    .paginate-dot {
      display: flex;
      align-self: center;
      color: ${colors.neutral_regular};

      strong{
        font-size: ${fontSizes.ml};
        text-align: center;
        margin-bottom: calc(50%);

        &:nth-child(2){
          margin: 0 3px;
        }
      }
    }
  }
`